// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"ceba4e1bde6d96fc13a1","245":"f5cb2cd4b454a2c4ab44","452":"8bd9bee4c32ad7d45e45","453":"2c19d3a030a5195aa46f"}[chunkId] + ".js";
};